import { initSwiper } from "./swiper-carousel";
import { initMobileSwiper } from "./mobile-swiper-carousel";

document.addEventListener('DOMContentLoaded', () => {
  const carouselElements = document.querySelectorAll<HTMLElement>('.js-swiper-carousel');
  const carouselMobileElements = document.querySelectorAll<HTMLElement>('.js-mobile-carousel');

  carouselElements.forEach((carousel) => {
    initSwiper(carousel);
  });

  carouselMobileElements.forEach((mobileCarousel) => {
    initMobileSwiper(mobileCarousel);
  });
});
